import { IconButton } from "@ameelio/ui";
import Clear from "@mui/icons-material/Clear";
import { Box, Card, Typography } from "@mui/material";

export default function GuestCard({
  title,
  subtitle,
  onRemove,
}: {
  title: string;
  subtitle: string;
  onRemove: () => void;
}) {
  return (
    <Card
      sx={{
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
        alignItems: "center",
        py: 3,
        px: 4,
        my: 2,
      }}
      variant="outlined"
    >
      <Box>
        <Typography
          variant="body1"
          sx={{
            color: "text.primary",
          }}
        >
          {title}
        </Typography>
        <Typography
          variant="body2"
          sx={{
            color: "text.secondary",
          }}
        >
          {subtitle}
        </Typography>
      </Box>
      <IconButton onClick={onRemove} ariaLabel="remove">
        <Clear />
      </IconButton>
    </Card>
  );
}
